import { useUserData } from '../contexts/UserDataContext';
import { formatUSD } from '../utils/formatters';

export function BalancesTab() {
  const { balance, accountValue, marginUsed, isConnected } = useUserData();

  // Don't show empty state during loading - just update values in place
  const showEmptyState = !isConnected || (!isConnected && accountValue === 0);
  const emptyMessage = !isConnected
    ? 'Connect wallet to view balances'
    : 'No balances';

  // Calculate available balance (total withdrawable - margin used in positions)
  const available = balance - marginUsed;
  const inOrders = 0; // TODO: Calculate from open orders

  return (
    <div className="h-full bg-[#0e0f10]">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#1a1d20]">
            <th className="px-3 py-1.5 h-6 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Asset
            </th>
            <th className="px-3 py-1.5 h-6 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Total
            </th>
            <th className="px-3 py-1.5 h-6 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Available
            </th>
            <th className="px-3 py-1.5 h-6 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              In Orders
            </th>
            <th className="px-3 py-1.5 h-6 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Account Value
            </th>
          </tr>
        </thead>
        <tbody>
          {showEmptyState ? (
            <tr>
              <td colSpan={5} className="px-3 py-8 text-center text-[#6c7884] text-[13px]">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            <tr className="hover:bg-[#13141a]">
              <td className="px-3 py-1.5 h-6 text-white font-medium text-[12px]">
                USDC
              </td>
              <td className="px-3 py-1.5 h-6 text-right text-white text-[12px]">
                {formatUSD(balance)}
              </td>
              <td className="px-3 py-1.5 h-6 text-right text-white text-[12px]">
                {formatUSD(available)}
              </td>
              <td className="px-3 py-1.5 h-6 text-right text-[#6c7884] text-[12px]">
                {formatUSD(inOrders)}
              </td>
              <td className="px-3 py-1.5 h-6 text-right text-white text-[12px] font-semibold">
                {formatUSD(accountValue)}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
